import React from 'react'

const IconClipboardList = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <rect x='5' y='4' width='14' height='17' rx='2' />
         <rect x='9' y='2' width='6' height='3' rx='1' />
         <line x1='8' y1='11' x2='16' y2='11' />
         <line x1='8' y1='15' x2='16' y2='15' />
         <line x1='8' y1='19' x2='13' y2='19' />
      </svg>
   )
}
export default IconClipboardList
